export default __webpack_public_path__ + "static/media/icon_pba_map.ddc969da.svg";